import ModalsUtil from '../../../utils/modals';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/profile';
import {changeAvatar} from '../../../reducers/user/actions';
import {logout} from '../../../reducers/auth/actions';
import {useNavigate} from 'react-router-dom';
import Language from '../../../language';
import ImageUtil from '../../../utils/image';

export default () => {
    const {user, changeAvatarButton} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate(),
          avatars = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];

    return (
        <div className="modal modal-profile animate__zoomIn animate__animated" data-target="profile" style={{display: 'none'}}>
            <div className="modal-background"></div>
            <div className="modal-close" onClick={() => ModalsUtil.close()}></div> 
            <div className="buttons">
                <div className="button profile">
                    <div className="text">{Language('modals.profile.nav.profile')}</div>
                </div>
                <div className="button information" onClick={() => ModalsUtil.open('messages')}>
                    <div className="text">{Language('modals.profile.nav.information')}</div>
                    {/* <div className="count">2</div> */}
                </div>
            </div>
            <div className="content">
                <div className="title">{Language('modals.profile.profile.title')}</div>
                <div className="avatars-content">
                    <div className="my-avatar">
                        <ImageUtil 
                            path={`/avatars/${user.avatar}.png`}
                            alt="Avatar" />
                        <div className="border"></div>
                    </div>
                    <div className="avatars-list">
                        {avatars.map((num, key) => {
                            return (
                                <div className={`avatar ${user.avatar === num ? 'active' : ''}`} key={key} onClick={e => {
                                    if(!changeAvatarButton)
                                        dispatch(changeAvatar(num));
                                }}>
                                    <ImageUtil 
                                        path={`/avatars/${num}.png`}
                                        alt="Avatar" />
                                    <div className="border"></div>
                                </div>
                            )
                        })} 
                    </div>
                </div>
                <div className="profile-buttons">
                    <div className="button-ok" onClick={() => {
                        ModalsUtil.close();
                        dispatch(logout(navigate));
                    }}>{Language('modals.profile.profile.buttons.logout')}</div> 
                    <div className="button-cp" onClick={() => ModalsUtil.open('password')}>{Language('modals.profile.profile.buttons.change_password')}</div>
                    {/* <div className="button-events" onClick={() => ModalsUtil.open('events')}>{Language('modals.profile.profile.buttons.events')}</div> */}
                </div> 
            </div>
        </div>
    )
}